import Axios from 'axios';
import { callFn } from '@/utils/functionsClient';
let token = null;
let pending = null;
async function bridge() {
    const { code } = await callFn('issueBackofficeToken');
    const request = await Axios.post(`${process.env.VUE_APP_KIDSCHOOL_API_URL}/api/v1/auth/exchange`, { code });
    return request.data.token;
}
export async function getToken() {
    if (token) {
        return token;
    }
    if (!pending) {
        pending = bridge().finally(() => { pending = null; });
    }
    token = await pending;
    return token;
}
/**
 * The employee behind the token. The note endpoints authorize the edit by this id,
 * so the card knows which notes are the instructor's own.
 */
export async function getEmployeeId() {
    const payload = (await getToken()).split('.')[1];
    if (!payload) {
        return '';
    }
    try {
        return JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/'))).employee_id ?? '';
    }
    catch (e) {
        console.error(e);
        return '';
    }
}
export function clearToken() {
    token = null;
}
